import { useSelector } from 'react-redux';

import { dateFormat } from 'common/helpers/dateHelper';

const NextShipDate = (props) => {
  const { clubMembership } = props;
  const settings = useSelector((state) => state.setting);

  return (
    <>
      Your next shipment is{' '}
      <span>
        {dateFormat(clubMembership.subscription.nextProcessDate, settings)}
      </span>
    </>
  );
};

export default NextShipDate;
